var exports = {
  "q": "xa15a2ab7--4fcbb1--price",
};

module.exports = exports;
